realmCommerceApp.factory('orderService', OrderService);

/*@ngInject*/
function OrderService(apiService) {

    var form = {
        model: {},
        fields: [
            {
                key: 'message',
                type: 'textarea',
                templateOptions: {
                    type: 'text',
                    placeholder: 'Message',
                    required: true
                }
            }
        ]
    };
    var statuses = [
        {
            name: 'Card',
            icon: 'fa-credit-card-alt',
            options: ["Paid", "Accepted", "Submitted", "Awaiting Approval", "Pending", "Processing", "Cancelled"]
        },
        {
            name: 'Box',
            icon: 'fa-cube',
            options: ["In Stock", "Potentially Delayed", "Amended", "Acknowleged", "Order Consolidating", "Cancelled", "New Order"]
        },
        {
            name: 'Refund',
            icon: 'fa-arrow-left',
            options: ["Refunded", "Refund", "Refund Requested", "Returned"]
        },
        {
            name: 'Complete',
            icon: 'fa-check',
            options: ["Received at Store", "Received", "Order Completed", "Delivered", "Collected by Customer"]
        },
        {
            name: 'Cancellation',
            icon: 'fa-times',
            options: ["Cancelled", "Void", "Cannot Source", "Failed", "Refund Requested", "Request Cancellation", "Cannot ship", "Failed", "Blacklisted", "Cancelled - Blacklisted"]
        },
        {
            name: 'Shipping',
            icon: 'fa-truck',
            options: ["Special Delivery (from Store)", "Special Dispatch (from Store)", "Dispatched"]
        },

    ];

    var service = {
        'statuses': statuses,
        'form': form,
        getOrdersByStatus: getOrdersByStatus,
        sendQueryOrderMessage: sendQueryOrderMessage,
    };
    return service;

    function getOrdersByStatus(status, limit, start) {
        return apiService.loadOrdersByStatus(status, limit, start);
    }

    function sendQueryOrderMessage(orderNumber, orderMessage) {
        return apiService.queryOrder(orderNumber, orderMessage);

    }

}



// WEBPACK FOOTER //
// ./static/js/app/services/order.service.js